import React, { useEffect } from "react";
import SuspendedCustomerTable from "../../components/customers/suspended customers/table";
import { useDispatch, useSelector } from "react-redux";
import animate from "../../assets/images/animate.gif";
import { fetchAllUsers } from "../../store/users";

const SuspendedCustomers = () => {
  const status = useSelector((state) => state.users.userFetchStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAllUsers());
    }
  }, [dispatch]);

  return (
    <>
      {status === "loading" ? (
        <div className="containerSubRight">
          <div className="loader-container">
            <img alt="Loading" src={animate} />
          </div>
        </div>
      ) : (
        <SuspendedCustomerTable />
      )}
    </>
  );
};

export default SuspendedCustomers;
